import application from 'application/application';
import textEditorTemplate from './text-edit-editor.template.html';

import textEditorController from './text-edit-editor.controller.js';

application.directive('ngEditTextEditor', [
	() => ({
		restrict: 'E',
		templateUrl: textEditorTemplate,
		controller: textEditorController
	})
]);
